import * as React from "react";
import { ToggleButtonGroup, ToggleButton } from "react-bootstrap";

interface IProps {
    status: number,
    onStatusChange: (status: number) => void
}

class Action extends React.Component<IProps, {}> {
    handleStatusChange = (status: number) => {
        this.props.onStatusChange(status);
    }

    render = () => {
        return (
            <>
                <ToggleButtonGroup type="radio" name="status">
                    <ToggleButton className={this.props.status == 1 ? "btn-success btn-sm" : "btn-default btn-sm"} value={1} onClick={() => this.handleStatusChange(1)}>Accept</ToggleButton>
                    <ToggleButton className={this.props.status == 2 ? "btn-danger btn-sm" : "btn-default btn-sm"} value={2} onClick={() => this.handleStatusChange(2)}>Dispute</ToggleButton>
                </ToggleButtonGroup>
            </>
        );
    }
}

export default Action;